import { request } from './http.js';
import { clearSession, setRoles, setSession } from './session.js';

/**
 * Signs in against /api/v1/auth/login.
 *
 * The field is called `email` because that is what MapIdentityApi's request model calls it, but the
 * backend seeds and matches on the *user name* - so this takes a user name and posts it there. The
 * seeded account signs in as `{ "email": "admin", "password": "admin123" }`.
 */
export async function login(userName, password)
{
   const tokens = await request('/api/v1/auth/login', {
      body: { email: userName, password },
      auth: false
   });

   setSession(tokens, userName);

   // What the operator may do, so a page can leave out what the server would refuse. A failure here is
   // not a failed sign-in: the pages then learn from the first refusal, as they always did.
   const me = await request('/api/v1/auth/me').catch(() => null);

   setRoles(me?.roles ?? []);

   return tokens;
}

/**
 * Drops the local token. Identity's bearer tokens are stateless, so there is nothing to revoke server
 * side - signing out is purely a client concern.
 */
export function logout()
{
   clearSession();
}

/** The signed-in account, from /api/v1/auth/manage/info. */
export function accountInfo()
{
   return request('/api/v1/auth/manage/info');
}
